import React, { useState } from 'react';
import {
  Autocomplete,
  TextField,
} from '@mui/material';
import { useMutation, useQueryClient, useQuery } from '@tanstack/react-query';
import '../../../App.css';
import { apiUrlPrefix } from '../../../config';
import Cookies from 'js-cookie';
import useStore from '../state-files/zustondStoreStates';

const GetUserCommunities = ({ formik, isAll }) => {
  const [open, setOpen] = useState(false);
  const { currentCommunityId, currentCommunityName } = useStore(); // Use zustand store

  // --- FETCHING Communities ---
  const getAllCommunities = async () => {
    try {
      const response = await fetch(apiUrlPrefix + "Communities/getUserCommunities?userId=" + localStorage.getItem('userId'), {
        method: "GET",
        credentials: "include",
        headers: { 'Content-Type': 'application/json' },
      });
      if (response.ok) {
        // 1. Capture the data in a variable
        const data = await response.json();

        // 2. LOG IT HERE to see the list in your console
        return await data;
      }
      return [];
    } catch (error) {
      console.error("Fetch failed:", error);
      return [];
    }
  };

  // Use TanStack Query to manage the community list
  const { data: communityData } = useQuery({
    queryKey: ['allCommunities'],
    queryFn: getAllCommunities,
    enabled: open, // Only fetch when the dialog is opened
  });

  var communityList;
  if (isAll) {
    communityList = ['All', ...(communityData?.map(user => user.name) || [])];
  } else {
    communityList = [...(communityData?.map(user => user.name) || [])];
  }

  return (
    <Autocomplete
      className="hidden"
      multiple // This must be inside the brackets
      id="users-search-select"
      options={communityList}
      // Use communities to match your field name
      value={formik.values.communities || [currentCommunityName]}
      onChange={(event, newValue) => {
        // 1. Identify what was just added
        const lastSelected = newValue[newValue.length - 1];
        let updatedValue = newValue;

        // 2. Logic: If "All" was just selected, make it the ONLY selection
        if (lastSelected === 'All' && isAll) {
          updatedValue = ['All'];
        }
        // 3. Logic: If a specific user was added and "All" is in the list, remove "All"
        else if (newValue.length > 1 && (newValue.includes('All') || newValue.includes('None'))) {
          updatedValue = newValue.filter((user) => user !== 'All' && user !== 'None');
        }
        else if (newValue.length < 1) {
          updatedValue = [currentCommunityName];
        }

        // 4. Update Formik
        formik.setFieldValue('communities', updatedValue);
      }}
      renderInput={(params) => (
        <TextField {...params} label="Select Community" />
      )}
    />
  )
};

export default GetUserCommunities;